import type { JSX } from 'react'

export const CrownIcon = (): JSX.Element => (
  <use href='#crownIcon' height='100%' width='100%' />
)
